export default "__VITE_ASSET__Ds7CUelI__"